export default __webpack_public_path__ + "static/media/sql.81392de9.svg";